import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CapabilityEngineService } from '../capabilityEngine.service';

@Injectable()
export class UsersListService {

    constructor(
        private _http: HttpClient,
        private _capEngineService: CapabilityEngineService
    ) { }

    performPagination(pageNumber) {
        let header = this._capEngineService.getHeaders('viewUserList');
        return this._http.get(environment.serverUrl + '/team/users/pagination/' + pageNumber, header);
    }

    updateUserDetails(obj) {
        return this._http.put(environment.serverUrl + '/user', obj);
    }
    assetsList(){
        return this._http.get(environment.serverUrl + '/assets')
    }
}



// WEBPACK FOOTER //
// ./src/app/users-list/users-list.service.ts